export function trackEvent(eventName, eventData) {
  analytics.track(eventName, {
    ...eventData
  });
}

export function identifyUser(userData) {
  analytics.identify(userData.id, {
    name: userData.username,
    email: userData.email
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/metric-analytics-service.js
 **/